export default __webpack_public_path__ + "static/metaImage-2e09d3decf594d3af069a9221f699d4a.jpg";